import React, { Component } from "react";
import { Row, Col } from 'react-bootstrap';

class TransferInformation extends Component {

  render() {
    return (
      <>
        <p className="text-muted">
          Los datos bancarios para efectuar tu pago mediante una transferencia, son los siguientes:
        </p>

        <div className="mt-3">
          <Row>
            <Col xs sm md lg={ 4 }>
              <strong>Número de cuenta:</strong>
            </Col>

            <Col>
              <span>0117630921</span>
            </Col>
          </Row>

          <Row>
            <Col xs sm md lg={ 4 }>
              <strong>No. Cuenta CLABE:</strong>
            </Col>

            <Col>
              <span>012180001176309212</span>
            </Col>
          </Row>

          <Row>
            <Col xs sm md lg={ 4 }>
              <strong>Banco:</strong>
            </Col>

            <Col>
              <span>BBVA</span>
            </Col>
          </Row>

          <Row>
            <Col xs sm md lg={ 4 }>
              <strong>Receptor:</strong>
            </Col>

            <Col>
              <span>WARETEK MEXICO SAPI DE CV</span>
            </Col>
          </Row>
        </div>
      </>
    )
  };
};

export default TransferInformation;
